import React , {useEffect} from 'react'
import {Route, Routes, useLocation} from 'react-router-dom';
import Footer from '../component/footer/Main'
import Hometwo from '../component/hometwo/Main'
import Homethree from '../component/homethree/Main'
import About from '../component/About/Main'
import Courses from '../component/Courses/Main'
import Coursestwo from '../component/coursestwo/Main'
import Coursesdeatils from '../component/coursedetails/Main'
import Coursesdeatilstwo from '../component/coursedetailstwo/Main'
import Event from '../component/Pages/event/Main'
import Eventdeatils from '../component/Pages/eventdeatils/Main'
import Gallery from '../component/Pages/gallery/Main'
import Pricing from '../component/Pages/Pricing/Main'
import Faq from '../component/Pages/Faq/Main'
import Teacher from '../component/Pages/Teacher/Main'
import Teacherdeatils from '../component/Pages/teacherdetails/Main'
import Error from '../component/Pages/error/Main'
import Blog from '../component/Blog/Main'
import Blogs from '../component/Pages/blogs/Main'
import Blogdetails from '../component/Blogdetails/Main'
import Contact from '../component/contact/Main'
import Projectdeatils from '../component/Pages/Projectdeatils/Main'
import Home from '../component/home/Main';
import Blogdetails1 from "../component/Pages/Blogdetails1/Main.js"
import Blogdetails2 from "../component/Pages/Blogdetails2/Main.js"
import Blogdetails3 from "../component/Pages/Blogdetails3/Main.js"
import Faculties from "../component/Pages/Faculties/Main.js"
import CampusLife from '../component/Pages/campuslife/Main'
import GalleryPage from '../component/Pages/gallery/Main'
import NewsEvents from '../component/Pages/newsevents/Main'

function Index() {
  const location = useLocation();
  const path = location.pathname
  useEffect(() => {
    window.scroll(0, 0)
}, [path]);
  return (
    <>
        <Routes>
           <Route path="/" element={<Home/>} />
           <Route path="/home-two" element={<Hometwo/>} />
           <Route path="/home-three" element={<Homethree/>} />
           <Route path="/about-us" element={<About/>} />
           <Route path="/courses" element={<Courses/>} /> 
           <Route path="/courses-2" element={<Coursestwo/>} /> 
           <Route path="/single-courses" element={<Coursesdeatils/>} /> 
           <Route path="/single-courses-2" element={<Coursesdeatilstwo/>} /> 
           <Route path="/event" element={<Event/>} /> 
           <Route path="/single-event" element={<Eventdeatils/>} /> 
           <Route path="/projects" element={<Gallery/>} /> 
           <Route path="/single-projects" element={<Projectdeatils/>} /> 
           <Route path="/pricing" element={<Pricing/>} /> 
           <Route path="/faq" element={<Faq/>} /> 
           <Route path="/team" element={<Teacher/>} /> 
           <Route path="/team-single" element={<Teacherdeatils/>} />  
           <Route path="/404-error" element={<Error/>} /> 
           <Route path="/news-events" element={<Blog/>} /> 
           
           <Route path="/faculties" element={<Faculties />} /> 
           <Route path="/blogs" element={<Blogs/>} /> 
           <Route path="/blogs/top-career-opportunities-after-bpharm" element={<Blogdetails1/>} />
           <Route path="/blogs/why-practical-training-matters-in-pharmacy-education" element={<Blogdetails2 />} />
           <Route path="/blogs/role-of-a-pharmacist-in-todays-healthcare-system" element={<Blogdetails3 />} />
           <Route path="/blog-details" element={<Blogdetails />} />  
           <Route path="/contact-us" element={<Contact/>} />

           <Route path="/campus-life" element={<CampusLife/>} />
           <Route path="/gallery" element={<GalleryPage/>} />
           {/* <Route path="/news-events" element={<NewsEvents/>} /> */}

           {/* Catch-all — redirects any unknown URL to the 404 page */}
           <Route path="*" element={<Error/>} />
        </Routes>
        <Footer/>
    </>
  )
}
export default Index
